import React from 'react';
import { useSettings } from '../context/SettingsContext';
import { useAuth } from '../context/AuthContext';

const SettingsMenu = ({ onClose }) => {
  const {
    mapTileProvider,
    setMapTileProvider,
    timezone,
    setTimezone,
    mapTileProviders,
    availableTimezones
  } = useSettings();
  
  const { user, logout } = useAuth();

  const handleMapTileChange = (e) => {
    const selectedProvider = mapTileProviders.find(p => p.name === e.target.value);
    if (selectedProvider) {
      setMapTileProvider(selectedProvider);
    }
  };

  const handleTimezoneChange = (e) => {
    setTimezone(e.target.value);
  };

  return (
    <div className="settings-menu">
      <div className="settings-header">
        <h3>Settings</h3>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      
      <div className="settings-user">
        {user && (
          <>
            <div className="user-info">
              <img
                src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`}
                alt="User avatar"
                onError={(e) => { e.target.src = 'https://cdn.discordapp.com/embed/avatars/0.png'; }}
              />
              <span>{user.username}</span>
            </div>
            <button className="logout-button" onClick={logout}>
              Logout
            </button>
          </>
        )}
      </div>
      
      <div className="settings-section">
        <h4>Map Settings</h4>
        
        <div className="setting-item">
          <label htmlFor="mapTileProvider">Map Style:</label>
          <select
            id="mapTileProvider"
            value={mapTileProvider.name}
            onChange={handleMapTileChange}
          >
            {mapTileProviders.map((provider) => (
              <option key={provider.name} value={provider.name}>
                {provider.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="settings-section">
        <h4>Display Settings</h4>
        
        <div className="setting-item">
          <label htmlFor="timezone">Timezone:</label>
          <select
            id="timezone"
            value={timezone}
            onChange={handleTimezoneChange}
          >
            {availableTimezones.map((tz) => (
              <option key={tz} value={tz}>
                {tz}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="settings-footer">
        <div className="version-info">Version 1.0.0</div>
      </div>
    </div>
  );
};

export default SettingsMenu;